import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"column small-12\">\r\n    <h3 class=\"h2\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":31}}}) : helper))) != null ? stack1 : "")
    + "</h3>\r\n    <div class=\"background\">\r\n        <ul class=\"jumbo\">\r\n            <li class=\"divider\">\r\n                <p class=\"header\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"applyOnline") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n                <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"applyOnline") : stack1)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"applyOnline") : stack1)) != null ? lookupProperty(stack1,"text2") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":16},"end":{"line":15,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"applyOnline") : stack1)) != null ? lookupProperty(stack1,"text3") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":16},"end":{"line":18,"column":23}}})) != null ? stack1 : "")
    + "            </li>\r\n            <li class=\"divider\">\r\n                <p class=\"header\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"shopCar") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n                <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"shopCar") : stack1)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n            </li>\r\n            <li>\r\n                <p class=\"header\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"closeDeal") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n                <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"closeDeal") : stack1)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n            </li>\r\n        </ul>\r\n        <p class=\"fineprint show-for-small-only\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"bottomDevices") || (depth0 != null ? lookupProperty(depth0,"bottomDevices") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"bottomDevices","hash":{},"data":data,"loc":{"start":{"line":29,"column":49},"end":{"line":29,"column":68}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        <p class=\"fineprint show-for-medium-up\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"bottomLarge") || (depth0 != null ? lookupProperty(depth0,"bottomLarge") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"bottomLarge","hash":{},"data":data,"loc":{"start":{"line":30,"column":48},"end":{"line":30,"column":65}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n\r\n    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <p class=\" secondarytext\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"applyOnline") : stack1)) != null ? lookupProperty(stack1,"text2") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"contents") : depth0)) != null ? lookupProperty(stack1,"applyOnline") : stack1)) != null ? lookupProperty(stack1,"text3") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":34,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/jumbotron-list-3-steps-auto-module",
  "version": "2.0.0",
  "id": "jumbotronList3StepsAutoModule",
  "containerID": "autoLoansJumbotronList3StepsAutoModule",
  "moduleName": "auto-loans-jumbotron-list-3-steps-auto-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "jumbotron-list-3-steps-auto-module",
  "data": {
    "init": "jumbotronList3StepsAutoModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @class jumbotronList3StepsAutoModule
 * @extends {Module}
 */
class jumbotronList3StepsAutoModule extends Module {
  /**
   * Creates an instance of jumbotronList3StepsAutoModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig,
      target: '.jumbotron-list-3-steps-auto-module'
    });
  }

  /**
   * Runs on module init
   * @returns {void}
   */
  init() {
    const getApp = document.querySelector('.get-app');
    if (getApp) {
      getApp.addEventListener('click', e => {
        e.preventDefault();
        // trigger the get app modal on click of this link
        spartaEventsUtility.pub('getAppModal:open');
      });
    }
  }
}
registerModuleClass({
  moduleClass: jumbotronList3StepsAutoModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { jumbotronList3StepsAutoModule as default, moduleConfig };
